module.exports = __webpack_public_path__ + "img/service-default-logo.bf1f03a4.png";